import { replaceMessagePlaceholders } from '@src/shared/includes/functions';

import messages from './messages.json';

type AlertAccessor = 'Alerts';
type AlertPluralName = 'Alerts';
type AlertSingularName = 'Alert';
type AlertSlug = 'alert';

export type Configuration = {
  accessor: AlertAccessor;
  messages: Record<string, any>;
  pluralName: AlertPluralName;
  singularName: AlertSingularName;
  slug: AlertSlug;
};

export const configuration: Configuration = {
  accessor: 'Alerts',
  messages: {},
  pluralName: 'Alerts',
  singularName: 'Alert',
  slug: 'alert',
};

configuration.messages = replaceMessagePlaceholders(messages, configuration.singularName);
